import { ToggleButtonGroup, ToggleButton, styled } from '@mui/material';

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    textTransform: 'none',
    padding: '3px 15px',
    fontWeight: 500,
    margin: '2px',
    color: theme.palette.text.primary,
    '&.Mui-selected': {
        backgroundColor: '#2e2a5c',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#252149'
        }
    },
    '&:hover': {
        backgroundColor: theme.palette.action.hover
    }
}));

// Custom styled ToggleButtonGroup for better appearance
export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    backgroundColor: '#fff',
    height: '32px',
    '& .MuiToggleButtonGroup-grouped': {
        margin: 2,
        border: 0
    }
}));
